import styles from "./notificationfilter.module.css";
import { Link } from "react-router-dom";
import { Plus, Search } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";
import FilterAutocomplete from "../../../components/FilterAutocomplete";

const TYPE_OPTIONS = [
    { value: "Email", label: "Email" },
    { value: "SMS", label: "SMS" },
];

const NotificationFilter = ({ filterData, setFilterData }) => {
    const { user, isAuthenticated } = useAuth0();

    return (<div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" value={filterData?.searchKey || ""} onChange={(e) => setFilterData(prev => {
                    return { ...prev, searchKey: e.target.value };
                })} />
            </div>
        </div>
        <div className={`${styles.FilterSec}`}>
            <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                <FilterAutocomplete
                    label="Type"
                    options={TYPE_OPTIONS}
                    value={filterData?.type}
                    onChange={(value) => setFilterData(prev => {
                        return { ...prev, type: value };
                    })}
                />
            </div>
            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("emailnotification:update") > -1 && <Link to={`/notification/email-sms-notification/add`} className={`${styles.AddNoteBu}`}>
                <Plus /> <span>Notification</span>
            </Link>}
        </div>
    </div>)
}

export default NotificationFilter;